





















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Section from "@/models/section.model";
import ProfileAttribute from "../../models/profileAttribute.model";
import MapProfileAttribute from "../../models/mapProfileAttribute.model";
import { Utils } from "@/core/Utils";
import CiudadanoService from "@/services/ciudadano.service";
import { ComponentImportConfigProp } from "../../models/componentImportConfig.model";

@Component({
  name: "profile-section"
})
export default class ProfileSection extends Vue {
  @Prop() public value!: Section;
  @Prop() public profile!: any;
  @Prop() public identifier!: any;

  section: Section = this.value != undefined ? this.value : new Section();
  noEspecificado = " - No especificado";
  mergeProblem = "Merge Problem";
  isComponentMergeModalActive = false;

  currentSolucionarValue: Array<any> = [];
  selectedSolucionador: any = null;
  currentSectionName = "";
  currentAttr: ProfileAttribute = new ProfileAttribute();
  loadingMerge: boolean = false;
  ciudadanoService: CiudadanoService = new CiudadanoService();
  componentInfoLoading = false;

  result: any = null;
  get isMobile(){
    return this.$store.state.isMobile;
  }
  async solucionarMerge() {
    this.loadingMerge = true;
    await this.ciudadanoService
      .resolveMergeConflict(
        this.selectedSolucionador.ciudadanoAtributoInfoInstitucionId,
        this.selectedSolucionador.ciudadanoAtributoId
      )
      .then(data => {
        let mapProfileAttribute: Array<MapProfileAttribute> = this.currentAttr
          .mapProfileAttribute;

        let propertyName =
          this.currentAttr.dataType.codigo !=
          "CONFIG_PROFILE_FIELD_DATA_TYPE_CONCATENADO"
            ? mapProfileAttribute[0].name
            : this.currentAttr.name.charAt(0).toLowerCase() +
              this.currentAttr.name.slice(1);

        this.profile[Utils.camelize(this.currentSectionName)][
          propertyName
        ] = this.selectedSolucionador.valor;

        this.$buefy.toast.open({
          message: "El conflicto se ha resuelto con éxito!",
          type: "is-success"
        });

        this.loadingMerge = false;
        this.isComponentMergeModalActive = false;
        this.$forceUpdate();
      })
      .catch(err => {
        this.$buefy.toast.open({
          message: "Ha ocurrido un problema conflicto no resuelto!",
          type: "is-danger"
        });
        this.loadingMerge = false;
      });
  }
  onClickSolucionador(attr: ProfileAttribute, sectionName: string) {
    this.isComponentMergeModalActive = !this.isComponentMergeModalActive;
    this.currentSolucionarValue = this.getPropertyValue(attr, sectionName);
    this.currentSectionName = sectionName;
    this.currentAttr = attr;
  }

  hasMergeProblem(attr: ProfileAttribute, sectionName: string) {
    var valor = this.getPropertyValue(attr, sectionName);
    return Array.isArray(valor);
  }

  getMergeAttributeFirstValue(attr: ProfileAttribute, sectionName: string) {
    var valor = this.getPropertyValue(attr, sectionName);
    return valor[0].valor || this.noEspecificado;
  }

  getPropertyValue(attr: ProfileAttribute, sectionName: string): any {
    let mapProfileAttribute: Array<MapProfileAttribute> =
      attr.mapProfileAttribute;

    let propertyName =
      attr.dataType.codigo != "CONFIG_PROFILE_FIELD_DATA_TYPE_CONCATENADO"
        ? mapProfileAttribute[0].name
        : attr.name.charAt(0).toLowerCase() + attr.name.slice(1);

    var valor = this.profile[Utils.camelize(sectionName)][propertyName];
    return valor;
  }

  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  
  validateCiudadanoServiceAttributeRequest(ids: any) {
    // Consulta rápida temporalmente desactivada.
    // return (this.isLoggedIn)
    //   ? this.ciudadanoService.getCiudadanoInfoByAttributeIds(this.identifier, ids)
    //   : this.ciudadanoService.getCiudadanoInfoByAttributeIdsWithoutAuth(this.identifier, ids);
    return this.ciudadanoService.getCiudadanoInfoByAttributeIds(
      this.identifier,
      ids
    );
  }

  get componentImportedProps() {
    if (!this.result) {
      this.componentInfoLoading = true;
      this.result = {};
      var propertiesToSearch: Array<ComponentImportConfigProp> = [];

      if (this.section.componentImportConfig != null) {
        this.section.componentImportConfig.properties.forEach(
          (x: ComponentImportConfigProp) => {
            if (x.isStaticValue) {
              this.result[x.name as string] = x.staticValue;
            } else {
              propertiesToSearch.push(x);
            }
          }
        );
        var ids = propertiesToSearch.map(x => x.profileAttributeId) as Array<
          number
        >;
        if (!ids.length) {
          this.componentInfoLoading = false;
        }
        this.validateCiudadanoServiceAttributeRequest(ids)
          .then(data => {
            propertiesToSearch.forEach(x => {
              if (x.profileAttributeId) {
                this.result[x.name as string] = data[x.profileAttributeId];
              }
              this.componentInfoLoading = false;
              this.$forceUpdate();
            });
          });
      }
    }

    return this.result;
  }

  getProfileValue(attr: ProfileAttribute, sectionName: string) {
    try {
      var valor = this.getPropertyValue(attr, sectionName);

      if (Array.isArray(valor)) {
        valor = this.mergeProblem;
      }
      if (valor === true || valor === false) {
        return valor;
      }
      return valor || this.noEspecificado;
    } catch (error) {
      return Utils.camelize(sectionName) + this.noEspecificado;
    }
  }

  @Watch("isComponentMergeModalActive")
  onModalChange(val: boolean) {
    if (!val) {
      this.currentSolucionarValue = [];
      this.selectedSolucionador = null;
    }
  }
}
